'use strict';

export { default } from './emailData.factory';